import { Stack } from '@mui/material';
import { TableSkeletonProps, SKELETON_INPUT_HEIGHT } from '../Skeleton.types';
import { SkeletonBox } from './SkeletonBox';

const TableSkeletonRow = ({ columns }: { columns: number }) => {
    return (
        <Stack direction="row" spacing={1.5} alignItems="center">
            <SkeletonBox width="100%" height={SKELETON_INPUT_HEIGHT} sx={{ flex: 1 }} />
            {Array.from({ length: columns - 1 }, (_, index) => (
                <SkeletonBox key={index} width={120} height={SKELETON_INPUT_HEIGHT} />
            ))}
        </Stack>
    );
};

export const TableSkeleton = ({ rows = 6, columns = 5, sx }: TableSkeletonProps) => {
    return (
        <Stack spacing={1.5} sx={sx}>
            {Array.from({ length: rows }, (_, index) => (
                <TableSkeletonRow key={index} columns={columns} />
            ))}
        </Stack>
    );
};
